/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosResponse } from "axios";

export const getRequest = async (endpoint: string, headers?: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axios.post(endpoint, {
      headers,
    });
    return response;
  } catch (error: any) {
    handlerApiError(error);
    return error.response;
  }
};

export const getRequestData = async (endpoint: string, headers?: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axios.get(endpoint, {
      headers,
    });
    return response;
  } catch (error: any) {
    handlerApiError(error);
    return error.response;
  }
};

export const updateData = async (endpoint: string, body?: any, headers?: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axios.post(endpoint, body, headers);
    return response;
  } catch (error: any) {
    handlerApiError(error);
    return error.response;
  }
};

export const updateDataByLeadId = async (
  endpoint: string,
  body?: any,
  headers?: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await axios.post(endpoint, body, headers);
    console.log("response: ", response);
    return response;
  } catch (error: any) {
    handlerApiError(error);
    return error.response;
  }
};

export const postRequest = async (endpoint: string, body?: any, headers?: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axios.post(endpoint, body, headers);
    return response;
  } catch (error) {
    handlerApiError(error);
    throw error;
  }
};

function handlerApiError(error: any): void {
  if (error.response) {
    console.error("API Error Response", error.response.data);
  } else if (error.request) {
    console.error("API Error Request", error.request);
  } else {
    console.error("API Error ", error.message);
  }
}

export const getSearchCompanyData = async (url: string, body: any) => {
  try {
    const response: AxiosResponse = await axios.post(url, body);
    return response.data.data;
  } catch (error) {
    handlerApiError(error);
    throw error;
  }
};

export const getCompanyDataById = async (url: string, body: any) => {
  try {
    const response: AxiosResponse = await axios.post(url, body);
    return response.data.data;
  } catch (error) {
    handlerApiError(error);
    throw error;
  }
};
